import { useEffect, useState } from 'react'
import LaunchIcon from '@mui/icons-material/Launch';

import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });

export default function Contact(props: any) {
	const { message, topMargin } = props;
	const [links, setLinks] = useState([
		{ value: 'https://botpenguin.com', title: 'Visit Telegram' },
		{ value: 'https://botpenguin.com', title: 'Visit Instagram' },
		{ value: 'https://botpenguin.com', title: 'Visit Facebook' },
		{ value: 'https://botpenguin.com', title: 'Visit Website' },
	]);
	useEffect(() => {
		setLinks(() => message.links);
	}, [message]);

	const redirectToUrl = (url: string) => {
		window.open(url, '_blank');
	}

	return (
		<>
			<div className='max-w-80 ele-contact'>
				<div id='ele-247' className={`ele-contact-message-label rounded-tl-xl rounded-tr-xl w-fit py-2 px-4 bg-primaryBgColor ${topMargin}`}>
					<p className='prose' dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
				</div>
				<div className="ele-contact-options options-container max-w-70 border-solid border-2 border-t-0 border-primaryBgColor rounded-bl-xl rounded-br-xl">
					{
						links.map(link => {
							return <>
								<div className="ele-contacts link cursor-pointer  flex justify-center p-2 items-center border-solid border-t-2 border-primaryBgColor hover:bg-secondaryBgColor" onClick={() => redirectToUrl(link.value)}>
									<LaunchIcon className="ele-contacts-launch-icon text-primaryColor text-base mr-1" />
									<p id='ele-250' className="ele-contacts-link-title text-primaryColor ">{link.title}</p>
								</div>
							</>
						})
					}
				</div>
			</div>
		</>
	)
}
